import { Navigate } from "react-router-dom";
import { useAuth } from '../../services/context/AuthContext'

const PublicRoute = ({ children, redirectTo }) => {
  const { authToken } = useAuth()
  return !authToken ? children : <Navigate to={redirectTo} />;
}

export default PublicRoute
